import { courseType } from "./dataType"

export const tech = [
  "Javascript","Python","HTML5","CSS3","NodeJS","React","GraphQL","Typescript","Go","Redux","Django","NestJS","Firebase","React Native","NextJS","TailwindCSS","Dart","Flutter"
]

export const Course:courseType[] = [
  {
    title:"[풀스택] 유튜브 클론코딩",
    subTitle:"유튜브 백엔드 + 프런트엔드 + 배포",
    link:"www.~.com",
    price:"유료",
    level:"초급",
    tech:["Javascript","NodeJS"],
    imgSrc:"smile.jpg"
  },
  {
    title:"코코아톡 클론코딩",
    subTitle:"HTML, CSS, Github",
    link:"www.~.com",
    price:"유료",
    level:"초급",
    tech:["HTML","CSS3", "Github"],
    imgSrc:"smile.jpg"
  },
  {
    title:"틱톡 클론코딩",
    subTitle:"Flutter, Firebase, Dart",
    link:"www.~.com",
    price:"유료",
    level:"중급",
    tech:["Flutter","Firebase", "Dart"],
    imgSrc:"smile.jpg"

  },
  {
    title:"[풀스택] 캐럿마켓 클론코딩",
    subTitle:"NextJS, Tailwind, PlanetScale, Cloudflare",
    link:"www.~.com",
    price:"유료",
    level:"중급",
    tech:["NextJS","TailwindCSS"],
    imgSrc:"smile.jpg"
  },
  {
    title:"[풀스택] 에어비앤비 클론코딩",
    subTitle:"에어비앤비 백엔드 + 프런트엔드 + 배포",
    link:"www.~.com",
    price:"유료",
    level:"중급",
    tech:["Python","React","Django"],
    imgSrc:"smile.jpg"
  },
  {
    title:"[풀스택] 우버 이츠 클론코딩",
    subTitle:"우버이츠 백엔드 + 프런트엔드 + 결제",
    link:"www.~.com",
    price:"유료",
    level:"고급",
    tech:["NestJS","Tailwind","React"],
    imgSrc:"smile.jpg"
  },
  {
    title:"노마드 코인",
    subTitle:"Go로 암호화폐 만들기",
    link:"www.~.com",
    price:"유료",
    level:"중급",
    tech:["Go"],
    imgSrc:"smile.jpg"
  },
  {
    title:"[풀스택] 인스타그램 클론코딩",
    subTitle:"인스타그램 백엔드 + 프런트엔드 + 앱 + 서버",
    link:"www.~.com",
    price:"유료",
    level:"중급",
    tech:["React","GraphQL","React Native"],
    imgSrc:"smile.jpg"
  },
  {
    title:"줌 클론코딩",
    subTitle:"WebSockets, SocketIO, WebRTC",
    link:"www.~.com",
    price:"무료",
    level:"초급",
    tech:["NodeJS"],
    imgSrc:"smile.jpg"
  },
  {
    title:"트위터 클론코딩",
    subTitle:"React Firebase For Beginners",
    link:"www.~.com",
    price:"무료",
    level:"중급",
    tech:["React","Javascript","Firebase"],
    imgSrc:"smile.jpg"
  },
  {
    title:"React Native 마스터클래스",
    subTitle:"Navigation, React Query, Animated, Realm",
    link:"www.~.com",
    price:"유료",
    level:"중급",
    tech:["React Native"],
    imgSrc:"smile.jpg"
  },
  {
    title:"React JS 마스터클래스",
    subTitle:"Typescript, Recoil, Framer Motion, Gatsby",
    link:"www.~.com",
    price:"유료",
    level:"중급",
    tech:["React","NodeJS"],
    imgSrc:"smile.jpg"
  },
  {
    title:"CSS Layout 마스터클래스",
    subTitle:"SCSS, Flexbox, CSS Grid",
    link:"www.~.com",
    price:"유료",
    level:"초급",
    tech:["CSS3"],
    imgSrc:"smile.jpg"
  },
  {
    title:"바닐라 JS로 크롬 앱 만들기",
    subTitle:"Javascript For Beginners",
    link:"www.~.com",
    price:"무료",
    level:"초급",
    tech:["Python"],
    imgSrc:"smile.jpg"
  },
  {
    title:"Python으로 웹 스크래퍼 만들기",
    subTitle:"Python For Beginners",
    link:"www.~.com",
    price:"무료",
    level:"초급",
    tech:["React"],
    imgSrc:"smile.jpg"
  },
  {
    title:"ReactJS로 영화 웹 서비스 만들기",
    subTitle:"왕초보를 위한 React",
    link:"www.~.com",
    price:"무료",
    level:"초급",
    tech:["NextJS"],
    imgSrc:"smile.jpg"
  },
  {
    title:"NextJS 시작하기",
    subTitle:"The React Framework for Production",
    link:"www.~.com",
    price:"무료",
    level:"중급",
    tech:["React Native"],
    imgSrc:"smile.jpg"
  },
  {
    title:"왕초보를 위한 React Native 101",
    subTitle:"React Native로 2개의 앱 만들기",
    link:"www.~.com",
    price:"무료",
    level:"초급",
    tech:["Dart"],
    imgSrc:"smile.jpg"
  },
  {
    title:"Dart 시작하기",
    subTitle:"Flutter 앱 개발을 위한 Dart 배우기",
    link:"www.~.com",
    price:"무료",
    level:"중급",
    tech:["Flutter"],
    imgSrc:"smile.jpg"
  },
  {
    title:"Flutter로 웹툰 앱 만들기",
    subTitle:"Flutter for Beginners",
    link:"www.~.com",
    price:"무료",
    level:"중급",
    tech:["Flutter"],
    imgSrc:"smile.jpg"
  },
  {
    title:"ES6의 정석",
    subTitle:"ES6, ES7, ES8",
    link:"www.~.com",
    price:"유료",
    level:"중급",
    tech:["Javascript"],
    imgSrc:"smile.jpg"
  },
  {
    title:"NestJS로 API 만들기",
    subTitle:"Enterprise Server Side Applications",
    link:"www.~.com",
    price:"무료",
    level:"고급",
    tech:["NextJS","Typescript"],
    imgSrc:"smile.jpg"
  },
  {
    title:"쉽고 빠른 Go 시작하기",
    subTitle:"Go for Beginners",
    link:"www.~.com",
    price:"무료",
    level:"중급",
    tech:["Go"],
    imgSrc:"smile.jpg"
  },
  {
    title:"바닐라 JS로 그림 앱 만들기",
    subTitle:"HTML, CSS, JS",
    link:"www.~.com",
    price:"무료",
    level:"초급",
    tech:["HTML5","CSS3","Javascript"],
    imgSrc:"smile.jpg"
  },
  {
    title:"실전형 리액트 Hooks 10개",
    subTitle:"Build your own Hooks Library",
    link:"www.~.com",
    price:"무료",
    level:"중급",
    tech:["React"],
    imgSrc:"smile.jpg"
  },
  {
    title:"초보자를 위한 리덕스 101",
    subTitle:"Learn the Basics",
    link:"www.~.com",
    price:"무료",
    level:"중급",
    tech:["Redux"],
    imgSrc:"smile.jpg"
  },
  {
    title:"Gulp 90분 마스터하기",
    subTitle:"Automate Your Workflow",
    link:"www.~.com",
    price:"무료",
    level:"초급",
    tech:["Javascript","NodeJS"],
    imgSrc:"smile.jpg"
  },
  {
    title:"Typescript로 블록체인 만들기",
    subTitle:"Typescript for Beginners",
    link:"www.~.com",
    price:"무료",
    level:"중급",
    tech:["Typescript"],
    imgSrc:"smile.jpg"
  },
  {
    title:"GraphQL로 영화 API 만들기",
    subTitle:"GraphQL for Beginners",
    link:"www.~.com",
    price:"무료",
    level:"중급",
    tech:["GraphQL"],
    imgSrc:"smile.jpg"
  },
  {
    title:"GraphQL로 영화 웹 앱 만들기",
    subTitle:"GraphQL + React for Beginners",
    link:"www.~.com",
    price:"무료",
    level:"중급",
    tech:["GraphQL"],
    imgSrc:"smile.jpg"
  },
  {
    title:"개발자를 위한 윈도우 셋업",
    subTitle:"WSL2, Windows Terminal, Ubuntu",
    link:"www.~.com",
    price:"무료",
    level:"초급",
    imgSrc:"smile.jpg"
  },
  {
    title:"초보를 위한 셀레니움",
    subTitle:"Python Browser Automation",
    link:"www.~.com",
    price:"무료",
    level:"초급",
    tech:["Python"],
    imgSrc:"smile.jpg"
  },
  {
    title:"초보를 위한 데이터 시각화",
    subTitle:"Introduction to Data Science",
    link:"www.~.com",
    price:"무료",
    level:"초급",
    tech:["Python"],
    imgSrc:"smile.jpg"
  },
  {
    title:"모두를 위한 깃 & 깃허브",
    subTitle:"Git & Github",
    link:"www.~.com",
    price:"무료",
    level:"초급",
    imgSrc:"smile.jpg"
  },
]